module.exports = __webpack_public_path__ + "b09eb457e92d5cf1983575a8ab71fe2a.svg";